import React from 'react'
export default function HorizontalSpacer({ size = 10 }) {
    return <div style={{ display: 'inline-block', width: size }}></div>
}